import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const SelfSerivceCatalogWrapper = styled('ul')({
    display: "flex",
    flexDirection: "column",
    gap: "25px",
    listStyle: "none",
    margin: 0,
    padding: 0,
    marginTop: "38px",
});

export const SelfSerivceCatalogGroup = styled('div')({
    margin: 0,
    padding: 0
});

export const SelfSerivceCatalogGroupTitle = styled('h2')(() => `
    font-weight: 700;
    font-size: 20px;
    line-height: 112.2%;
    color: #424242;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;

    & span:nth-child(1) {
        width: 52px;
        height: 4px;
        background: #EB0A1E;
        border-radius: 100;
    }
`);

export const SelfSerivceCatalogGroupItems = styled('ul')({
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(450px, 1fr))",
    gridGap: "24px",
    listStyle: "none",
    margin: 0,
    padding: 0,
    marginTop: "20px",
});

export const SelfSerivceCatalogGroupItem = styled('li')(() => `
    border: 1px solid rgba(66, 66, 66, 0.32);
    border-radius: 8px;
    padding: 2px;
    width: 100%;
    display: flex;
    flex-direction: column;
`);

export const SelfSerivceCatalogTop = styled('div')(() => `
    display: flex;
    gap: 8px;
    padding: 10px 14px;
    align-items: center;
    border-bottom: 1px solid rgba(66, 66, 66, 0.32);
`);

export const SelfSerivceCatalogTitle = styled('div')(() => `
    font-weight: 700;
    font-size: 16px;
    line-height: 112.2%;
    color: #000000;
`);

export const SelfSerivceCatalogIconWrapper = styled('div')(() => `
    width: 25px;
    height: 25px;
    background: #EB0A1E;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`);

export const SelfSerivceCatalogIconContainer = styled('span')(() => `
    flex-shrink: 0;
    filter: brightness(0) invert(1);
    display: flex;
    justify-content: center;
    align-items: center;
`);

export const SelfSerivceCatalogDown = styled('div')(() => `
    padding: 14px;
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 24px;
`);

export const SelfSerivceCatalogDescription = styled('p')(() => `
    font-weight: 400;
    font-size: 14px;
    line-height: 122%;
    color: #424242;
    margin: 0;
`);

export const SelfSerivceCatalogPreRequisiteTitle = styled('div')(() => `
    font-weight: 700;
    font-size: 14px;
    line-height: 122%;
    color: #000000;
    margin-top: 12px;
`);

export const SelfSerivceCatalogPreRequisites = styled('ul')(() => `
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0;
    margin-top: 5px;
    padding-inline-start: 35px;
`);

export const SelfSerivceCatalogPreRequisite = styled('li')(() => `
    font-weight: 400;
    font-size: 14px;
    line-height: 122%;
    color: #424242;
`);

export const SelfServiceCatalogFooter = styled('div')(() => `
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    align-items: center;
`);

export const SelfServiceCatalogFooterLeft = styled('div')(() => `
    font-weight: 400;
    font-size: 12px;
    line-height: 122%;
    color: #424242;
`);

export const SelfServiceCatalogFooterLink = styled(Link)(() => `
    color: #EB0A1E;
    text-decoration: underline;
    font-weight: 700;
`);
